export class ThemeLogic {
  public static allowExtendedUserLoginRoutes(): boolean {
    // I build-flag sono sempre booleani
    return !!process.env.BUILD_FLAGS_EXTENDED_USER_LOGIN;
  }
}
